export default __webpack_public_path__ + "static/media/draingPadBW.2f644edf.png";